import { ThemeProvider } from '@emotion/react';
import { Grid } from '@mui/material';
import { createTheme, styled } from '@mui/material/styles';
import * as React from 'react';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#36899f',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const MainGrid = styled(Grid)(({ theme }) => ({
  margin: '0rem',
  marginTop: '8rem',
}));

const FeaturedAuctionsBody = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <MainGrid container style={{ maxWidth: '1300px' }}>
          {/* <Grid item xs={12} style={{padding: "0rem 2rem",}}>
                  <HeadingText>Hot Auctions</HeadingText>
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{padding: "10px", display: "flex", justifyContent: "center"}}>
                    <AuctionCard />
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{padding: "10px", display: "flex", justifyContent: "center"}}>
                    <AuctionCard />
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{padding: "10px", display: "flex", justifyContent: "center"}}>
                    <AuctionCard />
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{padding: "10px", display: "flex", justifyContent: "center"}}>
                    <AuctionCard />
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{padding: "10px", display: "flex", justifyContent: "center"}}>
                    <AuctionCard />
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{padding: "10px", display: "flex", justifyContent: "center"}}>
                    <AuctionCard />
                </Grid> */}
        </MainGrid>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default FeaturedAuctionsBody;
